<template>
    <v-app light>
        <h1 class="titleExtranet">Messagerie</h1>
        <div class="text-align-center" v-if="loader === true">
            <loader></loader>
        </div>
        
        <span v-else>
            <div v-if="erreur == ''">
                <div class="sous-titre">
                    <div>
                        Bienvenue sur votre espace de messagerie.<br />
                        Envoyez-nous votre question ou votre demande. Votre interlocuteur dédié vous répondra dans les meilleurs délais.<br />
                        (Merci de créer une conversation distincte pour chaque nouvelle question/demande afin d’assurer un meilleur suivi.)
                    </div>
                    <div
                    v-if="$storeContact.TypeContact.find(e=> e === 4939)">
                    <br/>
                        Cet espace est exclusivement destiné aux questions techniques (changement de CIN ou d’adresse e-mail, mise à jour des informations personnelles, etc.).<br />
                        <br />
                        Pour toute autre demande (demande d’information, complément de dossier, éligibilité aux programmes ou autre), veuillez envoyer votre message à l’adresse suivante : <a href="mailto:admission@um6p.ma">admission@um6p.ma</a>
                    </div>
                    <div class="alignRight">
                        <v-btn @click.native="afficherModal()" class="btnModeListe">Nouvelle conversation +</v-btn>
                    </div>
                    <ConversationNouveau v-show="showModal" @close="fermerModal" />
                </div>
                

                <v-content v-if="conversations != null && conversations.length > 0">
                    <div class="subtab-content">
                        <div class="b-table">
                            <table class="table" v-if="conversations != null && conversations.length > 0">
                                <thead><tr><th></th><th>Objet</th><th>Date du dernier message</th></tr></thead>
                                <tbody>
                                    <tr v-for="conversation in conversations" :key="conversation.Id">
                                        <td class="tdIcon"><span class="icon is-small"><i class="mdi mdi-message-text"></i></span></td>
                                        <td><a :href="'#/conversation/details?id='+conversation.id+'&token='+token">{{ conversation.objet }}</a></td>
                                        <td>{{ conversation.dateDerniereMessage }}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <div v-else>Il n'y a pas de conversation</div>
                        </div>
                    </div>

                </v-content>
                <div v-else>
                    Il n'y a pas de conversation.
                </div>

                <div>
                    <div v-if="showErreurConversation" class="popup-overlay">                     
                      <div class="popup">
                        <p>Vous avez déja deux messages en cours de traitement.</p>
                        <button class="close-button" @click="showErreurConversation = false">Fermer</button>
                      </div>                     
                    </div>
                </div>
            </div>
            <!--Message d'erreur si le cas se présente-->
            <div id="divErreur" v-else>
                {{this.erreur}}
            </div>
        </span>
    </v-app>
</template>


<script>
    import Loader from "@/components/Loader.vue";
    import axios from 'axios';
    import ConversationNouveau from '@/components/Contact/ConversationNouveau.vue';

    export default {
        components: {
            Loader,
            ConversationNouveau
        },
        data() {
            return {
                conversations: [],
                loader: true,
                showModal: false,
                erreur: '',
                token: '',
                $storeContact: this.$storeContact,
                showErreurConversation: false
            }
        },
        mounted() {
            if(this.$route.query.token)
            {
                this.token = decodeURIComponent(this.$route.query.token.replace(/\+/g, " ")).replace(/ /g, "+");
                this.loader = true;
                let self = this;

                Promise.all([
                    this.$storeContact.GetListeObjets(this.token),
                    this.$storeContact.GetTypeContact(this.token),
                    this.chargerListe(),
                ])
                .then(function () {
                    self.loader = false;
                })
                .catch(() => {
                    this.loader = false;
                });
            }
        }
        ,
        methods: {
            /**********************************************************
            * Nom : chargerListe
            * Role : Charger la liste
            **********************************************************/
            chargerListe() {
                const url = process.env.VUE_APP_BASE_API_URL + "messagerie/conversations";
                axios({
                    method: "get",
                    url: url,
                    withCredentials: false,
                    headers: {
                        token: this.token,
                        Accept: 'application/json',
                    }
                })
                    .then(response => {
                        this.loader = false;
                        if (response.status == 200) {
                            if (response.data.erreur != null && response.data.erreur != '') {
                                this.erreur = response.data.erreur;
                            }
                            else {
                                this.conversations = response.data;
                            }
                        }
                        else {
                            this.erreur = "Aucune donnée correspondante n'a été récupérée.";
                        }
                    })
                    .catch(error => {
                        this.loader = false;
                        this.erreur = "Une erreur est survenue lors de la tentative de récupération des données.";
                        console.log(error);
                    });
            },

            afficherModal() {
                const url = process.env.VUE_APP_BASE_API_URL + "messagerie/checkconversations";
                axios({
                    method: "get",
                    url: url,
                    withCredentials: false,
                    headers: {
                        token: this.token,
                        Accept: 'application/json',
                    }
                })
                    .then(response => {
                        this.loader = false;
                        if (response.status == 200) {
                            if (response.data.erreur != null && response.data.erreur != '') {
                                this.erreur = response.data.erreur;
                            }
                            else {
                                if(response.data == false){
                                    this.showModal = true;
                                }
                                else{
                                    this.showErreurConversation = true;
                                }
                                
                            }
                        }
                        else {
                            this.erreur = "Aucune donnée correspondante n'a été récupérée.";
                        }
                    })
                    .catch(error => {
                        this.loader = false;
                        this.erreur = "Une erreur est survenue lors de la tentative de récupération des données.";
                        console.log(error);
                    });
                
            },

            fermerModal(data) {
                this.showModal = false;
                if (data.id != null && data.id != "") {
                    window.location.href = "#/conversation/details?id=" + data.id + '&token=' + this.token;
                }
            }
        }
    };
</script>

<style scoped src="@/assets/css/Messagerie.css">

</style>